import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";
import { getFirestore } from "firebase/firestore";

const apiKey = process.env.REACT_APP_FIREBASE_KEY;
const firebaseConfig = {
  apiKey: apiKey,
  authDomain: "jkbms-56767.firebaseapp.com",
  databaseURL: "https://jkbms-56767-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "jkbms-56767",
  storageBucket: "jkbms-56767.firebasestorage.app",
  messagingSenderId: "237714948489",
  appId: "1:237714948489:web:3ea01113e20278f3d4a158",
  measurementId: "G-F7TMXJF3J2"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Firebase references
const auth = getAuth(app);
const db = getDatabase();
const fs = getFirestore();

export { app, auth, db, fs };
